import { Image, Mic } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { QuestionType } from "app/types";
import React from "react";

interface MediaTooltipProps {
  question: QuestionType;
  quiz: {
    type: string;
  };
  QUIZ_TYPES_CONTANTS: any;
}
const MediaTooltip: React.FC<MediaTooltipProps> = ({
  question,
  quiz,
  QUIZ_TYPES_CONTANTS,
}) => {
  if (!question?.files?.length) {
    return null;
  }

  return +quiz.type === QUIZ_TYPES_CONTANTS.AUDIOMETRY ? (
    <Tooltip
      title={
        question?.files[0]?.tempUri ? (
          <div
            style={{
              width: "250px",
              marginTop: "10px",
              borderWidth: 3,
              borderColor: "#ccc",
            }}
          >
            <audio controls style={{ width: "100%" }}>
              <source src={question?.files[0].tempUri || ""} />
              Seu navegador não suporta áudio.
            </audio>
          </div>
        ) : (
          <></>
        )
      }
    >
      <Mic />
    </Tooltip>
  ) : (
    <Tooltip
      title={
        question?.files[0]?.tempUri ? (
          <img
            style={{ width: "200px", height: "auto" }}
            src={question?.files[0].tempUri || ""}
            alt={question?.question?.quest || ""}
          />
        ) : (
          <></>
        )
      }
    >
      <Image />
    </Tooltip>
  );
};
export default MediaTooltip;
